import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { useModal } from '~composables/common/use-modal'
import { useNavigate } from '~/composables/common/use-navigate'
import { ModalCollection } from '~/constants'

interface IModalContent {
  tabId: string
  description: string
}

export function useModalInformation() {
  const router = useRouter()
  const currentModalId = ref('')
  const { openNewTab } = useNavigate()
  const dataModal = computed((): IModalContent => {
    return getModal(currentModalId.value)
  })
  const { closeModal, getModal, openModal } = useModal()
  const getModalId = (modalId: string): void => {
    currentModalId.value = modalId
  }

  function closeModalInfo(modalId: string): void {
    closeModal(modalId)
  }
  function checkDisplayedVersion(link: string, isMobile: boolean): void {
    void openNewTab(link, true, isMobile)
    closeModal(ModalCollection.DISPLAYED_VERSION)
  }
  const redirectDeposit = (modalId: string, link: string): void => {
    closeModal(modalId)
    void router.push(link)
  }
  const openModalSecureSite = (): void => {
    const date = useCookie('dateShowModalSite').value
    const nowDate = dayjs().format('YYYY-MM-DD')
    if (date !== nowDate) {
      openModal(ModalCollection.SECURE_SITE)
      useCookie('dateShowModalSite', { maxAge: 60 * 60 * 24 }).value = nowDate
      return
    }
    closeModal(ModalCollection.SECURE_SITE)
  }
  return {
    closeModalInfo,
    getModalId,
    redirectDeposit,
    checkDisplayedVersion,
    dataModal,
    openModal,
    openModalSecureSite
  }
}
